import React, { useState } from "react";
import PropTypes from "prop-types";
import Table from "react-bootstrap/Table";
import TableCustomersAOM from "./TableCustomersAOM";
import TableCustomersBigQuery from "./TableCustomersBigQuery";
import { FaRegFileExcel } from "react-icons/fa";
import ExportJsonExcel from "js-export-excel";
import { Spinner } from "react-bootstrap";


const voidDataArray = [];

const TableClientesFechas = ({ dataClients }) => {
  const [showTCAOM, setShowTCAOM] = useState(false);
  const [showTCBigQuery, setShowTCBigQuery] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    dataCustomersBigQuery,
    dataTransactionsBigQuery,
    dataCustomersAOM,
    dataTransactionsAOM,
  } = dataClients[0];
  console.log("dataClients(TableClientsFechas):...", dataClients);

  const toggleShowTCAOM = () => {
    setShowTCAOM((prev) => !prev);
  };
  const toggleShowTCBigQuery = () => {
    setShowTCBigQuery((prev) => !prev);
  };

  const handleExportExcel = (id) => {
    //const { id } = e.target;
    console.log("handleExportExcel...", id);
    setLoading(true);
    let myDate = new Date().toISOString().slice(0, 10);

    switch (id) {
      case "customersAOM":
        exportConsult(dataCustomersAOM.data, `customersCRM_${myDate}`);
        break;
      case "transactionsAOM":
        exportConsult(dataTransactionsAOM.data, `transactionsCRM_${myDate}`);
        break;
      case "customersBigQuery":
        exportConsult(
          dataCustomersBigQuery.data,
          `customersBigQuery_${myDate}`
        );
        break;
      case "transactionsBigQuery":
        exportConsult(
          dataTransactionsBigQuery.data,
          `transactionsBigQuery_${myDate}`
        );
        break;
      default:
        console.log("No se selecciono un id valido");
        setLoading(false);
        break;
    }
  };

  const exportConsult = (arrayUsers, nameFile) => {
    console.log("Exportaremos la consulta:..", arrayUsers);

    let columnWidthsArray = [];
    let keysLength = Object.keys(arrayUsers[0]).length;

    for (let i = 0; i <= keysLength; i++) {
      columnWidthsArray.push(15);
    }

    let option = {};

    option.fileName = nameFile;

    option.datas = [
      {
        sheetData: [...arrayUsers],
        sheetName: "consulta1",
        sheetFilter: Object.keys(arrayUsers[0]),
        sheetHeader: Object.keys(arrayUsers[0]),
        columnWidths: [...columnWidthsArray],
      },
    ];

    let toExcel = new ExportJsonExcel(option); //new
    toExcel.saveExcel(); //guardando
    console.log("Ya deberia de existir el archivo:..", toExcel);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    //setLoading(false);
  };

  return (
    <div>
      {loading === true && (
        <Spinner
          animation="border"
          className="m-2 p-2 d-block ms-auto me-auto "
          variant="secondary"
        />
      )}
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>
              <div className="d-flex justify-content-start align-items-center gap-3">
                <span
                  id="customersAOM"
                  onClick={() => handleExportExcel("customersAOM")}
                  className="btn btn-outline-success"
                >
                  <FaRegFileExcel />
                </span>
                <span>Customers CRM</span>
              </div>
            </th>
            <th>
              <div className="d-flex justify-content-start align-items-center gap-3">
                <span
                  id="customersBigQuery"
                  onClick={() => handleExportExcel("customersBigQuery")}
                  className="btn btn-outline-success"
                >
                  <FaRegFileExcel />
                </span>
                <span>Customers BigQuery</span>
              </div>
            </th>
            <th>
              <div className="d-flex justify-content-start align-items-center gap-3">
                <span
                  id="transactionsCRM"
                  onClick={() => handleExportExcel("transactionsAOM")}
                  className="btn btn-outline-success"
                >
                  <FaRegFileExcel />
                </span>
                <span>Transactions CRM</span>
              </div>
            </th>

            <th>
              <div className="d-flex justify-content-start align-items-center gap-3">
                <span
                  id="transactionsBigQuery"
                  onClick={() => handleExportExcel("transactionsBigQuery")}
                  className="btn btn-outline-success"
                >
                  <FaRegFileExcel />
                </span>
                <span>Transactions BigQuery</span>
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td
              style={{ cursor: "pointer" }}
              onClick={toggleShowTCAOM}
              className="text-end"
            >
              {dataCustomersAOM.data.length}
            </td>
            <td
              style={{ cursor: "pointer" }}
              onClick={toggleShowTCBigQuery}
              className="text-end"
            >
              {dataCustomersBigQuery.data.length}
            </td>
            <td className="text-end">{dataTransactionsAOM.data.length}</td>
            
            <td className="text-end">{dataTransactionsBigQuery.data.length}</td>
          </tr>
        </tbody>
      </Table>

      {showTCAOM === true && (
        <TableCustomersAOM
          dataCustomersAOM={
            dataCustomersAOM?.data.length > 0
              ? dataCustomersAOM.data
              : voidDataArray
          }
          setShowTCAOM={setShowTCAOM}
        />
      )}
      {showTCBigQuery === true && (
        <TableCustomersBigQuery
          dataCustomersBigQuery={
            dataCustomersBigQuery?.data.length > 0
              ? dataCustomersBigQuery.data
              : voidDataArray
          }
          setShowTCBigQuery={setShowTCBigQuery}
        />
      )}
    </div>
  );
};

TableClientesFechas.propTypes = {
  dataClients: PropTypes.array.isRequired,
};

export default TableClientesFechas;
